module.exports = __webpack_public_path__ + "img/fastcharger-definitive-private.d097df62.png";